import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

// SVG Imports
import ISO2700 from "../../../assets/landingPage/ISO27001.png";
import ISO9001 from "../../../assets/landingPage/ISO9001.png";
import LinkdIn from "../../../assets/landingPage/LinkedIn.svg";
import NavXpentraLogo from "../../../assets/landingPage/NavXpentraLogo.svg";
import NavXpentraLogoMob from "../../../assets/landingPage/NavXpentraLogoMob.svg";

// REDUX Imports
import { toast_position } from "../../../redux/features/Settings/Authorization";
import SVGComponent from "../../_utils/SVGComponent";
import ICONS from "../../../assets/Icons";

const Footer = () => {
  // useNavigate
  const navigate = useNavigate();

  // useLocation
  const location = useLocation();
  const currentYear = new Date().getFullYear();

  const isActive = (route) => location.pathname === route;

  // useLocation
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const isBookDemoPage = location.pathname === "/book_demo";
  const [isHover, setIsHover] = useState(false);
  const arrowDirection = "right";

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const showToast = () => {
    toast.info("Feature coming soon!", toast_position);
  };

  return (
    <>
      <div>
        {isMobile ? (
          <>
            <div className="bg-[#031F4F]">
              <div className="flex flex-col justify-center pb-5 bg-[#031F4F]">
                <div className="mx-auto py-5">
                  <img
                    src={ICONS?.XPENTRA_WHITE}
                    alt="loader-new"
                  />
                </div>
                <div className="text-text-primary">
                  <p className="text-font-xl text-center font-semibold pb-2.5">
                    See Xpentra in action
                  </p>
                  <p className="text-xs text-center">
                    Request a personalised demo to explore how it can <br />{" "}
                    streamline your operations!
                  </p>
                </div>
                <div className="mt-[20px] mx-auto">
                  <div
                    onClick={() => {
                      if (!isBookDemoPage) {
                        navigate("/book_demo");
                      }
                    }}
                    onMouseEnter={() => !isBookDemoPage && setIsHover(true)}
                    onMouseLeave={() => !isBookDemoPage && setIsHover(false)}
                    className={`rounded-[5px] w-[215px] text-center text-xs font-semibold py-[10px] flex gap-2.5 items-center justify-center   ${
                      isBookDemoPage
                        ? "text-[#1D3A6D] bg-[#707070] cursor-not-allowed"
                        : "text-[#1D3A6D] bg-text-primary hover:bg-[#1D3A6D] hover:text-text-primary cursor-pointer"
                    }`}
                  >
                    Click here to request a demo
                    <SVGComponent
                      url={ICONS?.ARROW_RIGHT_WHITE}
                      height={"12px"}
                      width={"12px"}
                      color={
                        isBookDemoPage
                          ? "var(--primary-bg)"
                          : isHover
                            ? "var(--text-primary)"
                            : "var(--primary-bg)"
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="border-t-[1px] border-t-text-secondary mx-[30px] py-[30px] flex flex-col gap-[30px]">
                <div className="flex flex-col gap-4 items-center">
                  <div>
                    <img
                      src={NavXpentraLogoMob}
                      alt="logo"
                    />
                  </div>
                  <div
                    onClick={() =>
                      window.open(
                        "https://www.linkedin.com/company/xpentra",
                        "_blank",
                      )
                    }
                    className="cursor-pointer"
                  >
                    <img
                      src={LinkdIn}
                      alt="linkdin"
                    />
                  </div>
                </div>
                <div className="text-xs text-text-primary font-normal text-center flex flex-col gap-3">
                  <div
                    className={`inline-block px-2 ${
                      isActive("/") ? "border-b-pending text-pending" : ""
                    }`}
                  >
                    <span onClick={() => navigate("/")}>Home</span>
                  </div>
                  {/* <div
                    className={`inline-block px-2 py-1 
                    ${
                      isActive("/bank_statement") ||
                      isActive("/view_all_balances")
                        ? "border-b-pending text-pending"
                        : ""
                    }`}
                  >
                    <span
                      className={`${
                        isActive("/bank_statement") ||
                        isActive("/view_all_balances")
                          ? "border-b-pending text-pending"
                          : ""
                      }`}
                      onClick={() => navigate("/bank_statement")}
                    >
                      Product
                    </span>
                  </div> */}
                  <div
                    className={`inline-block px-2 py-1 ${
                      isActive("/product")
                        ? "border-b-pending text-pending"
                        : ""
                    }`}
                  >
                    <span onClick={() => navigate("/product")}>Product</span>
                  </div>
                  <div
                    className={`inline-block px-2 py-1 ${
                      isActive("/aboutus") || isActive("/advisors")
                        ? "border-b-pending text-pending"
                        : ""
                    }`}
                  >
                    <span
                      className={`${
                        isActive("/aboutus") || isActive("/advisors")
                          ? "border-b-pending text-pending"
                          : ""
                      }`}
                      onClick={() => navigate("/aboutus")}
                    >
                      About Us
                    </span>
                  </div>
                  <div
                    className={`inline-block px-2 py-1 ${
                      isActive("/pricing")
                        ? "border-b-pending text-pending"
                        : ""
                    }`}
                  >
                    <span onClick={() => navigate("/pricing")}>Pricing</span>
                  </div>
                  <div
                    className={`inline-block px-2 py-1 ${
                      isActive("/contactus")
                        ? "border-b-pending text-pending"
                        : ""
                    }`}
                  >
                    <span onClick={() => navigate("/contactus")}>
                      Contact Us
                    </span>
                  </div>
                  <div
                    className={`inline-block px-2 py-1 ${
                      isActive("/faq") ? "border-b-pending text-pending" : ""
                    }`}
                  >
                    <span
                      onClick={() => {
                        showToast();
                      }}
                    >
                      FAQ
                    </span>{" "}
                  </div>
                </div>
                <div className="flex flex-col items-center text-text-primary text-xs">
                  <div className="flex items-center gap-4">
                    <div className="w-[77.78px] py-5">
                      <a
                        href="https://ssl.comodo.com/ev-ssl-certificates.php"
                        // id="comodoTL"
                      >
                        <img
                          src="https://q2pay.in/new_assets/web/sectigo_trust_seal.png"
                          alt="Secured By Entrust, SSL (Secure Sockets Layer). Verify"
                          className=" "
                        />
                      </a>
                    </div>
                    <div className="w-[30px] py-5">
                      <img
                        src={ISO9001}
                        alt="ISO9001"
                      />
                    </div>
                    <div className="w-[30px] py-5">
                      <img
                        src={ISO2700}
                        alt="ISO2700"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-center gap-2.5 text-center text-text-primary text-xs">
                  <div
                    className={`border-b border-current cursor-pointer ${
                      isActive("/terms_conditions")
                        ? "text-pending border-b-pending"
                        : "hover:text-pending hover:border-pending"
                    }`}
                    onClick={() => navigate("/terms_conditions")}
                  >
                    Terms and Conditions
                  </div>
                  <div
                    className={`border-b border-current cursor-pointer ${
                      isActive("/privacy_policy")
                        ? "text-pending border-b-pending"
                        : "hover:text-pending hover:border-pending"
                    }`}
                    onClick={() => navigate("/privacy_policy")}
                  >
                    Privacy Policy
                  </div>
                  <span>
                    © Copyright {currentYear} Q2Pay Technologies Pvt Ltd. All
                    rights reserved
                  </span>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className={`bg-[#031F4F]`}>
            <div className="max-w-[1024px] mx-auto pt-[30px] flex flex-col gap-4">
              <div className="flex flex-col justify-center pb-8">
                <div className="mx-auto">
                  <img
                    src={ICONS?.XPENTRA_WHITE}
                    alt="loader-new"
                  />
                </div>
                <div className="text-text-primary mb-[30px]">
                  <p className="text-font-xl text-center font-semibold mb-2.5">
                    See Xpentra in action
                  </p>
                  <p className="text-xs text-center">
                    Request a personalised demo to explore how it can <br />
                    streamline your operations!
                  </p>
                </div>
                <div className="mx-auto">
                  <div
                    onClick={() => {
                      if (!isBookDemoPage) {
                        navigate("/book_demo");
                      }
                    }}
                    onMouseEnter={() => !isBookDemoPage && setIsHover(true)}
                    onMouseLeave={() => !isBookDemoPage && setIsHover(false)}
                    className={`rounded-[5px] w-[215px] text-center text-xs font-semibold py-[10px] flex gap-2.5 items-center justify-center ${isBookDemoPage ? "text-[#1D3A6D] bg-text-secondary cursor-not-allowed" : "text-[#1D3A6D] bg-text-primary hover:bg-[#1D3A6D] hover:text-text-primary cursor-pointer"}`}
                  >
                    Click here to request a demo
                    <SVGComponent
                      url={ICONS?.ARROW_RIGHT_WHITE}
                      height={"12px"}
                      width={"12px"}
                      color={
                        isBookDemoPage
                          ? "var(--primary-bg)"
                          : isHover
                            ? "var(--text-primary)"
                            : "var(--primary-bg)"
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="flex justify-between">
                <div className="flex flex-col gap-4">
                  <div>
                    <img
                      src={NavXpentraLogo}
                      alt="NavXpentraLogo"
                      className="ml-[-8px]"
                    />
                  </div>
                  <div className="flex gap-2.5 ">
                    <div
                      onClick={() =>
                        window.open(
                          "https://www.linkedin.com/company/xpentra",
                          "_blank",
                        )
                      }
                      className="cursor-pointer"
                    >
                      <img
                        src={LinkdIn}
                        alt="linkedin"
                      />
                    </div>
                  </div>
                </div>

                <div className="flex flex-col gap-[15px] text-text-primary text-xs pt-2">
                  <div className="flex justify-start gap-[50px]">
                    <div className={`w-[75px]`}>
                      <span
                        className={`hover:text-pending cursor-pointer ${
                          isActive("/")
                            ? "text-pending border-b-pending border-b border-current"
                            : ""
                        }`}
                        onClick={() => navigate("/")}
                      >
                        Home
                      </span>
                    </div>
                    {/* <div className={`w-[75px]`}>
                      <span
                        className={`hover:text-pending cursor-pointer ${
                          isActive("/bank_statement") ||
                          isActive("/view_all_balances")
                            ? "border-b-pending text-pending border-b border-current"
                            : ""
                        }`}
                        onClick={() => navigate("/bank_statement")}
                      >
                        Product
                      </span>
                    </div> */}
                    <div className={`w-[75px]`}>
                      <span
                        className={`hover:text-pending cursor-pointer ${
                          isActive("/product")
                            ? "text-pending border-b-pending border-b border-current"
                            : ""
                        }`}
                        onClick={() => navigate("/product")}
                      >
                        Product
                      </span>
                    </div>

                    <div className={`w-[75px]`}>
                      <span
                        className={`hover:text-pending cursor-pointer ${
                          isActive("/aboutus") || isActive("/advisors")
                            ? "text-pending border-b-pending border-b border-current"
                            : ""
                        }`}
                        onClick={() => navigate("/aboutus")}
                      >
                        About Us
                      </span>
                    </div>
                    {/* <div className={`w-[75px]`}>
                      <span
                        className={`hover:text-pending cursor-pointer ${
                          isActive("/pricing")
                            ? "text-pending border-b-pending border-b border-current"
                            : ""
                        }`}
                        onClick={() => navigate("/pricing")}
                      >
                        Pricing
                      </span>
                    </div> */}
                  </div>
                  <div className="flex justify-start gap-[50px]">
                    <div className={`w-[75px]`}>
                      <span
                        className={`hover:text-pending cursor-pointer ${
                          isActive("/pricing")
                            ? "text-pending border-b-pending border-b border-current"
                            : ""
                        }`}
                        onClick={() => navigate("/pricing")}
                      >
                        Pricing
                      </span>
                    </div>
                    <div className={`w-[75px]`}>
                      <span
                        className={`hover:text-pending cursor-pointer ${
                          isActive("/contactus")
                            ? "text-pending border-b-pending border-b border-current"
                            : ""
                        }`}
                        onClick={() => navigate("/contactus")}
                      >
                        Contact Us
                      </span>
                    </div>
                    <div className={`w-[75px] `}>
                      <span
                        className={`hover:text-pending cursor-pointer ${
                          isActive("/faq")
                            ? "text-pending border-b-pending border-b border-current"
                            : ""
                        }`}
                        onClick={() => showToast()}
                      >
                        FAQs
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex items-center text-text-primary text-xs">
                <div className="flex gap-2">
                  <div className="w-[77.78px] py-5">
                    <a
                      href="https://ssl.comodo.com/ev-ssl-certificates.php"
                      // id="comodoTL"
                    >
                      <img
                        src="https://q2pay.in/new_assets/web/sectigo_trust_seal.png"
                        alt="Secured By Entrust, SSL (Secure Sockets Layer). Verify"
                      />
                    </a>
                  </div>
                  <div className="w-[30px] py-5">
                    <img
                      src={ISO9001}
                      alt="ISO9001"
                    />
                  </div>
                  <div className="w-[30px] py-5">
                    <img
                      src={ISO2700}
                      alt="ISO2700"
                    />
                  </div>
                </div>

                <div className="flex flex-grow gap-2.5 justify-center">
                  <div
                    className={`border-b border-current cursor-pointer ${
                      isActive("/terms_conditions")
                        ? "text-pending border-b-pending"
                        : "hover:text-pending hover:border-pending"
                    }`}
                    onClick={() => navigate("/terms_conditions")}
                  >
                    Terms and Conditions
                  </div>
                  <div
                    className={`border-b border-current cursor-pointer ${
                      isActive("/privacy_policy")
                        ? "text-pending border-b-pending"
                        : "hover:text-pending hover:border-pending"
                    }`}
                    onClick={() => navigate("/privacy_policy")}
                  >
                    Privacy Policy
                  </div>
                  <span>
                    © Copyright {currentYear} Q2Pay Technologies Pvt Ltd. All
                    rights reserved
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Footer;
